export const assetKeys = {
  allAssetKey: ["asset"],
  assets: () => [...assetKeys.allAssetKey, "assetList"],
  asset: params => [...assetKeys.allAssetKey, params],
  favAssets: params => ["favList", params],
  allRecAssetKey: ["recAsset"],
  recAsset: params => [...assetKeys.allRecAssetKey, params],
};
